import React from 'react';
import Helmet from 'react-helmet';
import Moment from 'moment-timezone';

import { LOADING } from 'stores/BaseStore';
import store from 'modules/report/stores/allocation';
import Header from './components/Header';
import Table from './components/Table';
import { ReportBody } from '@/components/reports/body';

class AllocationLayout extends React.Component {
  state = {
    serachParams:{
      startDate: Moment(),
      endDate: Moment(),
    }
  }
  loadData = () => {
    store.getAllAllocations(this.state.serachParams).finally(()=>this.setState({}));
    this.setState({})
  }
  handleChangeDates = ({startDate, endDate}) => {
    let serachParams = this.state.serachParams;
    serachParams.startDate = startDate;
    serachParams.endDate = endDate;
    this.setState({serachParams}, () => {
      if (startDate && endDate) {
        this.loadData();
      }
    });
  }
  allocationById = (id) => {
    return store.getAllocation(id)
  }
  componentDidMount () {
    this.loadData();
  }
  render () {
    return (
      <div>
        <Helmet title="Anomalies" />
        <Header 
          onChangeDates={this.handleChangeDates}
          dates={this.state.serachParams}
          sync={this.loadData}
          isLoading={store.status === LOADING}/>
        <ReportBody>
          <Table
            data={store.data}
            dates={this.state.serachParams}
            allocationById={this.allocationById}
          />
        </ReportBody>
      </div>
    );
  }
}

export default AllocationLayout;
